import { render, staticRenderFns } from "./OrganizationAndVehicle.vue?vue&type=template&id=0782a7f1"
import script from "./OrganizationAndVehicle.vue?vue&type=script&lang=js"
export * from "./OrganizationAndVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports